// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"22ab4e76bdfe7add5b99","655":"5f5d2f56ce5794d73dee"}[chunkId] + ".js";
};